import React from "react";
import { useNavigate } from "react-router-dom";
import bgImage from "../assets/TruckBox.png";

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="relative h-screen w-screen overflow-auto">
      {/* Responsive full-screen background image */}
      <section className="relative min-h-screen bg-gradient-to-b from-black to-neutral-900 overflow-hidden">
        {/* Background Animation/Pattern */}
        <div className="absolute inset-0 opacity-20">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
              backgroundSize: '60px 60px',
            }}
          ></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 py-16 flex flex-col lg:flex-row items-center min-h-screen">
          {/* Left Side - Text Content */}
          <div className="lg:w-1/2 space-y-8 text-center lg:text-left">
            <div className="space-y-6">
              {/* <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#FF8A0C]/10 border border-[#FF8A0C]/20 backdrop-blur-sm">
                <span className="text-[#FF8A0C] text-sm font-semibold">🚀 AI-Powered Logistics Revolution</span>
              </div> */}
              <h1 className="text-4xl lg:text-6xl font-bold text-white leading-tight">
                Smart Truck Loading
                <br />
                <span className="bg-gradient-to-r from-[#FF8A0C] to-orange-400 bg-clip-text text-transparent">
                  AI Solution
                </span>
              </h1>
              <p className="text-lg text-gray-300 leading-relaxed max-w-2xl">
                Optimize your logistics with advanced AI that calculates perfect box dimensions and maximizes truck space utilization. Save time, reduce costs, and eliminate waste.
              </p>

              {/* Statistics */}
              <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 py-2">
                <div className="text-center">
                  <div className="text-3xl lg:text-4xl font-bold text-[#FF8A0C]">95%</div>
                  <div className="text-sm text-gray-400">Space Efficiency</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl lg:text-4xl font-bold text-[#FF8A0C]">50%</div>
                  <div className="text-sm text-gray-400">Cost Reduction</div>
                </div>
                <div className="text-center lg:col-span-1 col-span-2">
                  <div className="text-3xl lg:text-4xl font-bold text-[#FF8A0C]">10K+</div>
                  <div className="text-sm text-gray-400">Boxes Optimized</div>
                </div>
              </div>
            </div>

            <div className="bg-gray-900/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700/50 
                transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-blue-500/10">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full 
                    flex items-center justify-center animate-pulse">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-white">
                  Advanced <span className="text-[#FF8A0C]">AI Algorithm</span>
                </h2>
              </div>

              <p className="text-gray-300 text-lg leading-relaxed mb-6">
                Our cutting-edge AI optimizes truck space utilization with precision-engineered algorithms. Experience lightning-fast calculations that maximize 3D space efficiency while reducing operational costs and eliminating waste.
              </p>
            </div>

          </div>

          {/* Right Side - AI Mapping Section */}
          <div className="lg:w-1/2 lg:pl-12 mt-12 lg:mt-0">
            <div className="relative">
              {/* Box Images */}
              {/* <div className="mb-8">
                <img
                  src="https://img.freepik.com/premium-photo/cardboard-with-duct-tape-mockup_659426-33.jpg"
                  alt="Box illustration"
                  className="w-full max-w-xl mx-auto"
                />
              </div> */}

              {/* Warehouse Background */}
              <div className="relative">
                <img
                  src={bgImage}
                  alt="Truck background"
                  className="w-full rounded-2xl opacity-80"
                />

                {/* AI Mapping Overlay */}
                {/* <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent rounded-2xl flex flex-col justify-end p-8"> */}
                {/* <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center animate-pulse">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" />
                        <path d="M12 2C13.09 2 14 2.91 14 4C14 5.09 13.09 6 12 6" stroke="white" strokeWidth="2" strokeLinecap="round" />
                        <path d="M12 18C10.91 18 10 18.91 10 20C10 21.09 10.91 22 12 22" stroke="white" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-white text-xl font-bold">
                        AI Based <span className="text-[#FF8A0C]">Mapping</span>
                      </h3>
                      <p className="text-gray-300">for your boxes</p>
                    </div>
                  </div> */}
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>

      </section>
      {/* Features Section */}
      <section className="py-20 bg-gradient-to-b from-neutral-900 to-black">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Why Choose <span className="text-primary">JustLoad</span>?
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Revolutionary AI technology that transforms how you pack and ship, delivering unmatched efficiency and cost savings.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: "🤖",
                title: "AI-Powered Precision",
                description: "Advanced machine learning algorithms analyze box dimensions with 99.9% accuracy for optimal packing solutions."
              },
              {
                icon: "⚡",
                title: "Lightning Fast Results",
                description: "Get instant packing recommendations in under 3 seconds. No more manual calculations or guesswork."
              },
              {
                icon: "💰",
                title: "Cost Optimization",
                description: "Reduce shipping costs by up to 50% through intelligent space utilization and waste elimination."
              },
              {
                icon: "📊",
                title: "Real-time Analytics",
                description: "Track packing efficiency, space utilization, and cost savings with comprehensive dashboards."
              },
              {
                icon: "🔧",
                title: "Easy Integration",
                description: "Seamlessly integrate with existing logistics systems via our powerful API and plugins."
              },
              {
                icon: "🌍",
                title: "Eco-Friendly",
                description: "Reduce carbon footprint by minimizing truck trips and optimizing package dimensions."
              }
            ].map((feature, index) => (
              <div
                key={index}
                className="bg-[rgba(40,40,40,0.7)] backdrop-blur-md border border-white/10 rounded-xl p-6 text-center transition-all duration-300 ease-in-out hover:bg-[rgba(40,40,40,0.8)] hover:border-white/15 hover:-translate-y-1 hover:shadow-lg group"
              >
                <div className="text-4xl mb-4 transform transition-transform duration-300 group-hover:scale-110">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-300 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              How It <span className="text-primary">Works</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Simple, fast, and intelligent. Get optimized packing solutions in just three easy steps.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {[
              {
                step: "01",
                title: "Upload Box Images",
                description: "Simply drag and drop photos of your boxes or packages. Our AI instantly recognizes dimensions and shapes.",
                icon: "📸"
              },
              {
                step: "02",
                title: "Select Vehicle Type",
                description: "Choose from our comprehensive database of truck categories and vehicle specifications for accurate planning.",
                icon: "🚛"
              },
              {
                step: "03",
                title: "Get Optimized Results",
                description: "Receive instant 3D visualization and packing recommendations that maximize space and minimize costs.",
                icon: "✨"
              }
            ].map((step, index) => (
              <div key={index} className="relative text-center">
                <div className="bg-[rgba(40,40,40,0.7)] backdrop-blur-md border border-white/10 rounded-xl p-8 relative z-10 transition-all duration-300 hover:-translate-y-1 hover:bg-[rgba(40,40,40,0.8)] hover:border-white/15 hover:shadow-lg">
                  <div className="text-6xl mb-6">{step.icon}</div>
                  <div className="text-primary text-lg font-bold mb-2">Step {step.step}</div>
                  <h3 className="text-2xl font-bold text-white mb-4">{step.title}</h3>
                  <p className="text-gray-300 leading-relaxed">{step.description}</p>
                </div>
                {index < 2 && (
                  <div className="hidden lg:block absolute top-1/2 -right-10 z-0">
                    <svg className="w-12 h-12 text-primary/30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gradient-to-b from-black to-neutral-900">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-8">
                Transform Your <span className="text-primary">Logistics Today</span>
              </h2>
              <div className="space-y-6">
                {[
                  "Reduce shipping costs by up to 50%",
                  "Eliminate manual dimension calculations",
                  "Increase packing efficiency by 95%",
                  "Real-time optimization recommendations",
                  "Seamless integration with existing systems",
                  "24/7 AI-powered support"
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center gap-4">
                    <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                      <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-lg text-gray-300">{benefit}</span>
                  </div>
                ))}
              </div>
              <div className="mt-8">
                <button
                  className="relative overflow-hidden bg-[#FF8A0C]/20 backdrop-blur-md border border-[#FF8A0C]/30 rounded-full text-[#FF8A0C] font-semibold py-4 px-8 cursor-pointer transition duration-300 ease-in-out hover:bg-[#FF8A0C]/30 hover:border-[#FF8A0C]/50 hover:-translate-y-1 hover:shadow-[0_15px_35px_rgba(255,138,12,0.2)] hover:text-white active:-translate-y-0.5 flex items-center gap-3 justify-center"
                  onClick={() => navigate("/login")}
                >
                  Try It Now
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
            <div className="relative">
              <div className="bg-[rgba(40,40,40,0.7)] backdrop-blur-md border border-white/10 rounded-xl p-8 transition-all duration-300 hover:-translate-y-1 hover:bg-[rgba(40,40,40,0.8)] hover:border-white/15 hover:shadow-lg">
                <div className="bg-gradient-to-br from-primary/20 to-orange-500/20 rounded-xl p-8 text-center">
                  <h3 className="text-2xl font-bold text-white mb-4">Ready to Optimize?</h3>
                  <p className="text-gray-300 mb-6">Join thousands of businesses saving money and time with AI-powered logistics.</p>
                  <div className="grid grid-cols-2 gap-4 text-center">
                    <div>
                      <div className="text-3xl font-bold text-primary">500+</div>
                      <div className="text-sm text-gray-400">Happy Customers</div>
                    </div>
                    <div>
                      <div className="text-3xl font-bold text-primary">99.9%</div>
                      <div className="text-sm text-gray-400">Accuracy Rate</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default HomePage;
